import { useEffect, useCallback } from 'react';

const OfflinePayment = ({ handlePayment, paymentData, useApplicantId }) => {
    const handleFreeCheckout = useCallback(async () => {
         handlePayment(true, paymentData, useApplicantId);
        }, [handlePayment, paymentData, useApplicantId]);
    useEffect(() => {
        handleFreeCheckout();
    }, [handleFreeCheckout, useApplicantId]);
};

export default OfflinePayment;
